module.exports = __webpack_public_path__ + "media/images/logo/Logo-200px-9e2c38bee04538c8249de3ed14a0b5cc.png";